/**
 * ## Reservation Controller
 *
 * @module src/controllers/reservation
 */

"use strict";

const component = require("../../components/component");
const notification = require("../../components/notification");
const block = require("../../components/block");
const calendar = require("../../components/calendar");
const modal = require("../../components/modal");
const print = require("../../components/print");
const layout = require("../../components/layout");
const location = require("../../controllers/location");
const conf = require("../../config");
const chart = require("../../controllers/chart");
const moment = require("moment-timezone");
const tabs = require("../../controllers/tabs");
const l = require("../../common").localization;
const availability = require("../../common").availability;
const ChartjsNode = require("chart.js");

let lastDate = Math.floor(Date.now() / 1000);
let resDate = 0;
let ctx;
let resChart;

/** Init
 */
const init = (kd) => {
  // add party button
  resDate = parseInt(moment().startOf("day").format("X"), 10);
  $("#tab_btn_addreservation").css("display", "none");
  $("#tab_btn_addreservation, #tab_btn_addreservation_wide").off();
  $("#tab_btn_addreservation, #tab_btn_addreservation_wide").fastClick((e) => {
    e.stopPropagation();
    e.preventDefault();

    const opt = {
      width: "90%",
      type: "addparty",
      subtype: "waitlist",
      mode: "reservations",
      h1: "Dialog Header",
      body: "This is the body text inside the dialog box",
      buttons: [
        {
          description: "cancel",
          value: "cancel...",
        },
        {
          description: "close",
          value: "close",
        },
        {
          description: "third",
          value: "close",
        },
      ],
    };

    const data = {
      kd,
      location: location.location,
    };

    modal.create(opt, data, (err, value) => {
      modal.destroy();
    });
  });

  // today

  const opt = {
    kd,
    targetDiv: "reservation_today",
    date: parseInt(moment().startOf("day").format("X"), 10),
    confirmation: true,
    filter: {
      name: true,
      time: false,
      note: false,
      preference: false,
    },
  };

  const data = {
    type: "reservation",
    domain: "reservation",
    h1: l.translate("Reservations"),
    h2: l.translate("Today"),
    expand: true,
    single: true,
    group: "all",
    refresh: 30,
    height: {
      min: 69 * 2,
    },
    status: {
      min: 1,
      max: 1,
    },
    size: {
      min: 1,
      max: 8,
    },
    waited: {
      min: 0,
      max: 2000,
    },
  };
  block.create(opt, data, (err, target_id, activity_id) => {
    if (target_id === "remind") {
      remindAll(kd, activity_id);
    } else {
      flyoutWaitlist(kd, target_id, activity_id, opt);
    }
  });

  // tomorrow

  const opt2 = {
    kd,
    targetDiv: "reservation_tomorrow",
    date: parseInt(moment().startOf("day").format("X"), 10) + 24 * 60 * 60,
    confirmation: true,
    filter: {
      name: true,
      time: false,
      note: false,
      preference: false,
    },
  };

  const data2 = {
    type: "reservation",
    domain: "reservation",
    h1: l.translate("Reservations"),
    h2: l.translate("Tomorrow"),
    expand: true,
    single: true,
    group: "all",
    refresh: 30,
    height: {
      min: 69 * 2,
    },
    status: {
      min: 1,
      max: 1,
    },
    size: {
      min: 3,
      max: 4,
    },
    waited: {
      min: 0,
      max: 2000,
    },
  };

  block.create(opt2, data2, (err2, target_id, activity_id) => {
    if (target_id === "remind") {
      remindAll(kd, activity_id);
    } else {
      flyoutWaitlist(kd, target_id, activity_id, opt2);
    }
  });

  // reservation wide content

  // search by name

  $("#reservation_search_name_btn").off();
  $("#reservation_search_name_btn").fastClick((e) => {
    if ($("#reservation_search").val().length < 3) {
      const opt3b = {
        position: "top",
        width: "90%",
        seconds: 3,
        h1: l.translate("Please enter at least 3 letters"),
        body: "",
        buttons: [
          {
            description: l.translate("Close"),
            value: "close",
          },
        ],
      };
      notification.create(opt3b, {}, (err6, value2) => {
        notification.destroy();
      });
    } else {
      layout.hideKeyboard();
      const opt3 = {
        kd,
        targetDiv: "reservations_search",
        date: parseInt(moment().startOf("day").format("X"), 10),
        static: true,
        mode: "name",
        query: $("#reservation_search").val(),
      };

      const data3 = {
        type: "reservation",
        domain: "reservation",
        h1: $("#reservation_search").val(),
        h2: l.translate("Search"),
        expand: true,
        single: false,
        group: "all",
        refresh: 30,
        height: {
          min: 69 * 2,
        },
        status: {
          min: 1,
          max: 1,
        },
        size: {
          min: 1,
          max: 8,
        },
        waited: {
          min: 0,
          max: 2000,
        },
      };
      block.create(opt3, data3, (err4, target_id, activity_id) => {
        flyoutWaitlist(kd, target_id, activity_id, opt3);
      });
    }
  });

  // search by custom note

  $("#reservation_search_custom_btn").off();
  $("#reservation_search_custom_btn").fastClick((e) => {
    if ($("#reservation_search_custom").val().length < 3) {
      const opt5b = {
        position: "top",
        width: "90%",
        seconds: 3,
        h1: l.translate("Please enter at least 3 letters"),
        body: "",
        buttons: [
          {
            description: l.translate("Close"),
            value: "close",
          },
        ],
      };
      notification.create(opt5b, {}, (err6, value2) => {
        notification.destroy();
      });
    } else {
      layout.hideKeyboard();
      const opt5 = {
        kd,
        targetDiv: "reservations_search",
        date: parseInt(moment().startOf("day").format("X"), 10),
        static: true,
        mode: "custom",
        query: $("#reservation_search_custom").val(),
      };

      const data5 = {
        type: "reservation",
        domain: "reservation",
        h1: $("#reservation_search_custom").val(),
        h2: l.translate("Search by custom notes"),
        expand: true,
        single: false,
        group: "all",
        refresh: 30,
        height: {
          min: 69 * 2,
        },
        status: {
          min: 1,
          max: 1,
        },
        size: {
          min: 1,
          max: 8,
        },
        waited: {
          min: 0,
          max: 2000,
        },
      };
      block.create(opt5, data5, (err4, target_id, activity_id) => {
        flyoutWaitlist(kd, target_id, activity_id, opt5);
      });
    }
  });

  $("#btn_reservation_quick").off();
  $("#btn_reservation_quick").fastClick((e) => {
    $("#btn_reservation_quick").addClass("theme_btn_green_highlight");
    $("#btn_reservation_detailed").removeClass("theme_btn_green_highlight");
    $("#reservation_quick").css("display", "block");
    $("#reservation_detailed").css("display", "none");
    $("#reservation_box_search").css("display", "block");
    $("#reservation_box_date").css("display", "none");
    $("#reservation_box_export").css("display", "none");
    $("#reservation_box_export_csv").css("display", "none");
  });

  $("#btn_reservation_detailed").off();
  $("#btn_reservation_detailed").fastClick((e) => {
    $("#btn_reservation_detailed").addClass("theme_btn_green_highlight");
    $("#btn_reservation_quick").removeClass("theme_btn_green_highlight");
    $("#reservation_detailed").css("display", "block");
    $("#reservation_quick").css("display", "none");
    $("#reservation_box_search").css("display", "none");
    $("#reservation_box_date").css("display", "block");
    $("#reservation_box_export").css("display", "block");
    if (
      conf.vars.NODE_ENV.indexOf("ios") > -1 ||
      conf.vars.NODE_ENV.indexOf("android") > -1
    ) {
      $("#reservation_box_export_csv").css("display", "none");
    } else {
      $("#reservation_box_export_csv").css("display", "block");
    }
  });

  $("#reservation_field_date").off();
  $("#reservation_field_date").fastClick((e) => {
    const optionsd = {
      target_id: "reservation_field_date",
      type: "calendar",
      position: "right",
      startDate: resDate * 1000,
      adjust: {
        x: -130,
        y: 13,
      },
      kd,
    };
    component.create(optionsd, {}, (err, value) => {
      resDate = parseInt(moment(value.date).startOf("day").format("X"), 10);
      refreshDetailsBlock(kd);
    });
  });

  $("#reservation_box_export_print").off();
  $("#reservation_box_export_print").fastClick(() => {
    const thisHTML = print.reservations(kd, resDate);
  });

  $("#reservation_box_export_csv").off();
  $("#reservation_box_export_csv").fastClick(() => {
    const loc = kd.doc("location")[0];
    let thisCSV = "";
    thisCSV += `${loc.name}\r\n`;
    thisCSV += `${l.translate("Reservations for")} \
${l.tcal(moment(resDate * 1000).format(l.translate("dddd MMMM Do YYYY")))}\r\n`;
    thisCSV += `${l.translate("Time")},`;
    thisCSV += `${l.translate("Size")},`;
    thisCSV += `${l.translate("Name")},`;
    thisCSV += `${l.translate("Table(s)")},`;
    thisCSV += `${l.translate("Phone")},`;
    thisCSV += `${l.translate("Seat Pref")},`;
    thisCSV += `${l.translate("Notes")}\r\n`;
    const res = kd.where(
      "reservation",
      (obj) => {
        if (
          obj.date === resDate &&
          obj.status === 1 &&
          obj.requireConfirmation === 0
        ) {
          return true;
        }
      },
      "time"
    );
    for (let i = 0; i < res.length; ++i) {
      thisCSV += `${block.indexToTime(res[i].time)},`;
      thisCSV += `${res[i].size},`;
      thisCSV += `${res[i].name.replace(/,/g, "")},`;
      thisCSV += `${res[i].preSelect.join(", ")},`;
      thisCSV += `${block.formatCell(res[i].cell)},`;
      let pref = res[i].preference.replace(/,/g, "");
      if (pref == l.translate("First Available")) {
        pref = l.translate("F/A");
      }
      thisCSV += `${pref},`;
      let notes = "";
      if (res[i].hasOwnProperty("customNotes") && res[i].customNotes) {
        notes += `${res[i].customNotes} - `;
      }
      res[i].notes.forEach((note) => {
        if (note.active) {
          notes += `${note.value.replace(/,/g, "")} - `;
        }
      });
      notes.slice(0, -2);
      thisCSV += `${notes}\r\n`;
    }
    const filename = `${moment(resDate * 1000).format(
      l.translate("dddd, MMMM Do YYYY")
    )}.csv`;
    const blob = new Blob([thisCSV], { type: "text/csv;charset=utf-8;" });
    if (navigator.msSaveBlob) {
      navigator.msSaveBlob(blob, filename);
    } else {
      const link = document.createElement("a");
      if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", filename);
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  });

  opt.kd.on("reservation.update", () => {
    refreshResBlock(kd, lastDate);
    refreshResCalendar(kd, lastDate);
    refreshDetailsBlock(kd, resDate);
  });

  setTimeout(() => {
    opt.kd.emit("reservation.update", {});
  }, 10);
};

const refreshDetailsBlock = (kd) => {
  $("#reservation_field_date").val(
    l.tcal(moment(resDate * 1000).format(l.translate("dddd, MMMM Do YYYY")))
  );
  const opt4 = {
    kd,
    targetDiv: "reservation_detailed_block",
    date: parseInt(
      moment(resDate * 1000)
        .startOf("day")
        .format("X"),
      10
    ),
    static: true,
    adjust: {
      x: 0 - conf.vars.viewportWidth / 1.5,
      y: 18,
    },
    position: "right",
    forcePosition: true,
  };

  const data4 = {
    type: "reservation",
    domain: "reservation",
    h1: moment(resDate * 1000).format(l.translate("ddd, MMM Do YYYY")),
    h2: l.translate("All Reservation Details By Date"),
    expand: true,
    single: false,
    detailed: true,
    group: "all",
    refresh: 30,
    height: {
      min: 69 * 2,
    },
    status: {
      min: 1,
      max: 1,
    },
    size: {
      min: 1,
      max: 8,
    },
    waited: {
      min: 0,
      max: 2000,
    },
  };

  block.create(opt4, data4, (err4, target_id, activity_id) => {
    if (target_id === "remind") {
      remindAll(kd, activity_id);
    } else {
      flyoutWaitlist(kd, target_id, activity_id, opt4);
    }
  });
};

const flyoutWaitlist = (kd, target_id, reservation_id, opts) => {
  const options = {
    target_id,
    type: "accordion",
    mode: "context_reservation",
    position: "left",
    adjust: {
      x: -5,
      y: 35,
    },
  };
  if (opts && opts.hasOwnProperty("forcePosition")) {
    options.forcePosition = opts.forcePosition;
  }
  if (opts && opts.hasOwnProperty("adjust") && opts.adjust) {
    options.adjust = opts.adjust;
    options.position = opts.position;
  }
  const data = {
    kd,
    activity: kd.doc("reservation", reservation_id)[0],
  };

  component.create(options, data, (err, data2) => {
    const rightNow = Math.floor(Date.now() / 1000);
    switch (data2.value) {
      case "seatparty": {
        const resdata = Object.assign({}, data2.activity);
        resdata.res_id = resdata._id;
        resdata.statusTimes = {
          added: rightNow,
          seated: rightNow,
        };
        delete resdata._id;
        chart.setSeatParty(resdata, "reservations");
        if (
          resdata.hasOwnProperty("preSelect") &&
          resdata.preSelect.length > 0
        ) {
          chart.chart.setHighlight(resdata.preSelect);
          kd.emit("chart.update", {});
        } else {
          kd.emit("directseat", { preference: data.activity.preference });
          tabs.tab(kd, "direct", {
            minimal: true,
            size: resdata.size,
          });
        }
        const opt = {
          position: "top",
          block: "header",
          width: "90%",
          seconds: 0,
          color: "#09e202",
          h1: l.translate("Please select a table to seat this reservation."),
          body: "",
          buttons: [
            {
              description: l.translate("Cancel"),
              value: "close",
            },
          ],
        };
        notification.create(opt, {}, (err2, value) => {
          kd.emit("directseat", { preference: null });
          notification.destroy();
          chart.clearSeatParty();
          chart.chart.clearHighlight();
          kd.emit("chart.update", {});
          tabs.tab(kd, "reservations");
        });
        break;
      }
      case "fulfill": {
        const proposed = {
          domain: "reservation",
          _id: data2.activity._id,
          status: 4,
        };
        kd.update(proposed)
          .then((result) => {
            const opt2 = {
              position: "top",
              width: "90%",
              seconds: 2,
              color: "#09e202",
              h1: l.translate(
                "The reservation has been fulfilled and removed from this " +
                  "list."
              ),
              body: "",
              buttons: [
                {
                  description: l.translate("Close"),
                  value: "close",
                },
              ],
            };
            notification.create(opt2, {}, (err6, value2) => {
              notification.destroy();
            });
          })
          .catch((err7) => {
            console.log("err7", err7);
          });
        break;
      }
      case "cancel": {
        const proposed = {
          domain: "reservation",
          _id: data2.activity._id,
          status: 4,
        };
        const opt = {
          position: "top",
          width: "90%",
          seconds: 0,
          h1: l.translate("Are you sure you want to cancel this reservation?"),
          body: "",
          buttons: [
            {
              description: l.translate("Yes, cancel it."),
              value: "cancelres",
            },
            {
              description: l.translate("No, leave it."),
              value: "close",
            },
          ],
        };
        notification.create(opt, {}, (err3, value) => {
          notification.destroy();
          if (value === "cancelres") {
            kd.update(proposed)
              .then((result) => {
                const opt2 = {
                  position: "top",
                  width: "90%",
                  seconds: 2,
                  color: "#09e202",
                  h1: l.translate("Reservation has been cancelled."),
                  body: "",
                  buttons: [
                    {
                      description: l.translate("Close"),
                      value: "close",
                    },
                  ],
                };
                notification.create(opt2, {}, (err6, value2) => {
                  notification.destroy();
                });
              })
              .catch((err7) => {
                console.log("err7", err7);
              });
          }
        });
        break;
      }
      case "movetowaitlist": {
        const proposedR = Object.assign({}, data2.activity);
        proposedR.res_id = proposedR._id;
        proposedR.join = [];
        proposedR.domain = "activity";
        proposedR.status = 1;
        proposedR.statusTimes = {
          added: Math.floor(Date.now() / 1000),
        };
        proposedR.alerts = 0;
        proposedR.quoted = 5;
        if (
          data2.activity.hasOwnProperty("cell") &&
          data2.activity.cell.length > 0
        ) {
          proposedR.type = 1;
        } else {
          proposedR.type = 5;
        }
        delete proposedR._id;
        delete proposedR._kd;
        delete proposedR.meta;
        delete proposedR.$loki;
        kd.update(proposedR)
          .then((result) => {
            const proposedT = {
              domain: "reservation",
              _id: result.res_id,
              status: 4,
            };
            return kd
              .update(proposedT)
              .then((result2) => {})
              .catch((err2) => {
                console.log("err2", err2);
              });
          })
          .catch((err3) => {
            console.log("err3", err3);
          });
        break;
      }
      case "details": {
        const opt6 = {
          width: "90%",
          type: "addparty",
          subtype: "waitlist",
          mode: "reservations",
          h1: "Dialog Header",
          body: "This is the body text inside the dialog box",
          buttons: [
            {
              description: "cancel",
              value: "cancel...",
            },
            {
              description: "close",
              value: "close",
            },
            {
              description: "third",
              value: "close",
            },
          ],
        };

        const data6 = {
          kd,
          location: location.location,
          activity: data2.activity,
        };
        modal.create(opt6, data6, (err6, value) => {
          modal.destroy();
        });
        break;
      }
      case "movetoresnoshows": {
        const proposed = {
          domain: "reservation",
          _id: data2.activity._id,
          status: 6,
        };
        const opt = {
          position: "top",
          width: "90%",
          seconds: 0,
          h1: l.translate(
            "Are you sure you want to move this to the reservation " +
              "no shows list?"
          ),
          body: "",
          buttons: [
            {
              description: l.translate("Yes, move it"),
              value: "moveres",
            },
            {
              description: l.translate("No, leave it"),
              value: "close",
            },
          ],
        };
        notification.create(opt, {}, (err3, value) => {
          notification.destroy();
          if (value === "moveres") {
            kd.update(proposed)
              .then((result) => {
                const opt2 = {
                  position: "top",
                  width: "90%",
                  seconds: 2,
                  color: "#09e202",
                  h1: l.translate(
                    "Reservation has been moved to the reservation " +
                      "no shows list."
                  ),
                  body: "",
                  buttons: [
                    {
                      description: l.translate("Close"),
                      value: "close",
                    },
                  ],
                };
                notification.create(opt2, {}, (err6, value2) => {
                  notification.destroy();
                });
              })
              .catch((err7) => {
                console.log("err7", err7);
              });
          }
        });
        break;
      }
      case "printchit": {
        modal.destroy();
        setTimeout(() => {
          const opt = {
            type: "reservation",
            location: location.location,
          };
          print.create(opt, data2.activity);
        }, 10);
        break;
      }
      default:
        break;
    }
  });
};

const refreshResBlock = (kd, last) => {
  const opt4 = {
    kd,
    targetDiv: "reservations_search",
    date: parseInt(
      moment(last * 1000)
        .startOf("day")
        .format("X"),
      10
    ),
    static: true,
  };

  const data4 = {
    type: "reservation",
    domain: "reservation",
    h1: moment(last * 1000).format(l.translate("ddd, MMM Do YYYY")),
    h2: l.translate("Search by date"),
    expand: true,
    single: false,
    group: "all",
    refresh: 30,
    height: {
      min: 69 * 2,
    },
    status: {
      min: 1,
      max: 1,
    },
    size: {
      min: 1,
      max: 8,
    },
    waited: {
      min: 0,
      max: 2000,
    },
  };

  block.create(opt4, data4, (err4, target_id, activity_id) => {
    if (target_id === "remind") {
      remindAll(kd, activity_id);
    } else {
      flyoutWaitlist(kd, target_id, activity_id, opt4);
    }
  });

  renderChart(kd, last);
};

const renderChart = (kd, date) => {
  const inventory = availability.byDate(kd, date);

  const chartData = {
    labels: [],
    parties: [],
    filled: [],
  };
  for (let i = 0; i < inventory.slots.length; ++i) {
    if (inventory.slots[i].limitIndex !== null) {
      chartData.labels.push(inventory.slots[i].description);
      chartData.parties.push(inventory.slots[i].parties);
      chartData.filled.push(inventory.slots[i].filled);
    }
  }

  $("#content_wide_col3").css("height", "auto");
  $("#content_wide_col3").css("visibility", "visible");

  $("#inventory_chart_title").html(
    `${l.translate("Reservation flow for")} ${moment(date * 1000).format(
      l.translate("MMM Do, YYYY")
    )}`
  );

  if (resChart) {
    resChart.data.labels = chartData.labels;
    resChart.data.datasets[0].data = chartData.parties;
    resChart.data.datasets[1].data = chartData.filled;
    setTimeout(() => {
      resChart.update();
    }, 10);
  } else {
    ctx = document.getElementById("reservation_inventory").getContext("2d");
    resChart = new ChartjsNode(ctx, {
      type: "line",
      data: {
        labels: chartData.labels,
        datasets: [
          {
            data: chartData.parties,
            label: l.translate("Dining Parties"),
            borderColor: "#18a5d9",
            fill: "origin",
            lineTension: 0,
          },
          {
            data: chartData.filled,
            label: l.translate("Dining Covers"),
            borderColor: "#17d64a",
            fill: "origin",
            lineTension: 0,
          },
        ],
      },
      options: {
        legend: {
          position: "bottom",
          labels: {
            fontColor: "#fff",
          },
        },
        title: {
          display: false,
          fontColor: "#fff",
          text: "Inventory",
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                fontColor: "#aaa",
                color: "#999",
              },
              gridLines: {
                display: true,
                color: "#666",
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                fontColor: "#ddd",
                color: "#999",
              },
              gridLines: {
                display: true,
                color: "#666",
              },
            },
          ],
        },
      },
    });
  }
};

const refreshResCalendar = (kd, last) => {
  const opt5 = {
    target_id: "reservation_search_box",
    startDate: lastDate * 1000,
    nodestroy: true,
    kd,
  };

  calendar.create(opt5, {}, (err, value) => {
    if (lastDate == parseInt(moment(value.date).format("X"), 10)) {
      const optionst = {
        target_id: value.target_id,
        location: location.location,
        type: "time",
        position: "right",
        availability: true,
        start: 72,
        date: lastDate,
        adjust: {
          x: -25,
          y: 25,
        },
      };
      component.create(optionst, { kd }, (err2, value2) => {
        // let resTime = value.index;
        const opt = {
          width: "90%",
          type: "addparty",
          subtype: "waitlist",
          mode: "reservations",
          h1: "Dialog Header",
          startTime: value2.index,
          startDate: lastDate,
          available: value2.available,
          body: "This is the body text inside the dialog box",
          buttons: [
            {
              description: "cancel",
              value: "cancel...",
            },
            {
              description: "close",
              value: "close",
            },
            {
              description: "third",
              value: "close",
            },
          ],
        };

        const data = {
          kd,
          location: location.location,
        };
        modal.create(opt, data, (err7, value7) => {
          modal.destroy();
        });
      });
    } else {
      lastDate = parseInt(moment(value.date).format("X"), 10);
      refreshResBlock(kd, lastDate);
    }
  });
};

const remindAll = (kd, date) => {
  const request = {
    options: {
      type: "resRemind",
      date,
    },
  };
  kd.rpc(request);
  const opt3b = {
    position: "top",
    width: "90%",
    seconds: 3,
    color: "#09e202",
    h1: l.translate("Reservations reminders have been sent for this date"),
    body: "",
    buttons: [
      {
        description: l.translate("Close"),
        value: "close",
      },
    ],
  };
  notification.create(opt3b, {}, (err6, value2) => {
    notification.destroy();
  });
};

module.exports = {
  init,
  remindAll,
};



/** WEBPACK FOOTER **
 ** ./src/controllers/reservation/index.js
 **/